function getElementIdFromHash(hash) {
  var _a;
  return (_a = hash.match(
    /^#?([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}).*$/
  )) == null ? void 0 : _a[1];
}

export { getElementIdFromHash };
//# sourceMappingURL=get-element-id-from-hash.js.map
